import {ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot} from '@angular/router';
import {PlatformsService} from '@core/services/platforms.service';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PublicResolver implements Resolve<Api.Platform> {

    constructor(private _router: Router,
                private _platforms: PlatformsService) {
    }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        try {
            const platform = await this._platforms.getPlatform();

            if (state.url === '/oops') {
                this._router.navigate(['/']).then(_ => _);
            }

            return platform;
        } catch (error) {
            if (state.url === '/oops') {
                return null;
            }

            this._router.navigate(['/oops']).then(_ => _);
            return null;
        }
    }

}
